import {
  BanModerationSvg,
  MDashboardSvg,
  ModerationQueueSvg,
  MReportsSvg,
  MUsersSvg,
} from 'assets/svg-icon';
import classNames from 'classnames';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { base } from 'routes/ModerationRoutes';
import './SidebarModeration.scss';

interface IPropsSidebaroderation {
  propName?: string;
}

export const SidebarModeration: React.FC<IPropsSidebaroderation> = () => {
  const { pathname } = useLocation();
  const activeSection = pathname.replace(`${base}/`, '').split('/')[0] || 'dashboard';

  const linkClassName = (section: string) =>
    classNames('sidebar-moderation__link', {
      'sidebar-active': activeSection === section,
    });

  return (
    <div className="sidebar-moderation">
      <ul className="sidebar-moderation__list">
        <li className="sidebar-moderation__item">
          <Link to={base + '/dashboard'} className={linkClassName('dashboard')}>
            <MDashboardSvg />
            <span>Dashboard</span>
          </Link>
        </li>
        <li className="sidebar-moderation__item">
          <Link to={base + '/queue'} className={linkClassName('queue')}>
            <ModerationQueueSvg />
            <span>Moderation Queue</span>
          </Link>
        </li>
        <li className="sidebar-moderation__item">
          <Link to={base + '/blocked/users'} className={linkClassName('blocked')}>
            <BanModerationSvg />
            <span>Blocked</span>
          </Link>
        </li>
        <li className="sidebar-moderation__item">
          <Link to={base + '/users'} className={linkClassName('users')}>
            <MUsersSvg />
            <span>Users</span>
          </Link>
        </li>
        <li className="sidebar-moderation__item">
          <Link to={base + '/channels'} className={linkClassName('channels')}>
            <MReportsSvg />
            <span>Channels</span>
          </Link>
        </li>
        {/* Future moderation sections are intentionally kept hidden until their pages are enabled. */}
      </ul>
    </div>
  );
};
